/**
 * Internal brand for currency pair.
 */
export var ICurrencyPairBrand;
(function (ICurrencyPairBrand) {
    ICurrencyPairBrand["_"] = "";
})(ICurrencyPairBrand || (ICurrencyPairBrand = {}));
/**
 * Internal brand for ISO4217.
 */
export var ISO4217Brand;
(function (ISO4217Brand) {
    ISO4217Brand["_"] = "";
})(ISO4217Brand || (ISO4217Brand = {}));
export var ICcyPairBrand;
(function (ICcyPairBrand) {
    ICcyPairBrand["_"] = "";
})(ICcyPairBrand || (ICcyPairBrand = {}));
